import { readJson } from './errors';

const API = process.env.REACT_APP_BACKEND_URL;

// Teacher-scoped call to /api/teacher/*. Throws on any non-2xx (readJson), so
// every caller must catch — a swallowed rejection is a silently lost save.
export const teacherApi = async (path, opts = {}) => {
  const token = localStorage.getItem('desky_token');
  const res = await fetch(`${API}/api/teacher${path}`, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...opts.headers },
  });
  return readJson(res);
};
